import { SettingFeatureData } from "../../types";

import { useTypedSelector } from ".";

export const useSettingFeature = (): SettingFeatureData | undefined =>
  useTypedSelector(state => state.setting.feature);
